import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

export const drHistoryQueryKeys = {
  all: ['drHistory'],
  latest: (params) => [...drHistoryQueryKeys.all, 'latest', params],
  range: (params) => [...drHistoryQueryKeys.all, 'range', params],
};

export const useDrHistoryLatest = (params = {}) => {
  return useQuery({
    queryKey: drHistoryQueryKeys.latest(params),
    queryFn: () => api.get('/DrHistory/api/dr/latest', { params }),
    staleTime: 5 * 60 * 1000,
  });
};

export const useDrHistoryRange = (params = {}) => {
  return useQuery({
    queryKey: drHistoryQueryKeys.range(params),
    queryFn: () => api.get('/DrHistory/api/dr/range', { params }),
    staleTime: 5 * 60 * 1000,
  });
};